import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import {
  BxModalActionsComponent,
  BxModalComponent,
  BxModalContentComponent,
  BxModalHeaderComponent,
  DialogRef,
} from '@beyonnex/bx-angular-ui';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { SimpleConfirmModalSettings } from './simple-confirm-modal.models';

@Component({
  selector: 'bxi-simple-confirm-modal',
  imports: [BxModalActionsComponent, BxModalComponent, BxModalHeaderComponent, BxModalContentComponent, TranslatePipe],
  templateUrl: './simple-confirm-modal.component.html',
  host: { class: 'block' },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SimpleConfirmModalComponent {
  private readonly translate = inject(TranslateService);

  ref: DialogRef<SimpleConfirmModalSettings, boolean | undefined> = inject(DialogRef);

  protected readonly confirmButtonText = computed(() => this.ref.data.confirmButtonText || this.translate.instant('system.confirm'));
  protected readonly cancelButtonText = computed(() => this.ref.data.cancelButtonText || this.translate.instant('system.cancel'));
}
